import styled from "styled-components";
import colors from "../../styles/colors";

export const RegisterSuccessWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  height: auto;
  background-color: ${colors.theme.galilDark};
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding: 20px;
`;

export const BackgroundImage = styled.img`
  width: 100%;
  bottom: 0;
  position: absolute;
`;

export const ContentContainer = styled.div`
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 40px);
  background: rgba(255, 255, 255, 0.12);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10.9px);
  -webkit-backdrop-filter: blur(10.9px);
  border: 1px solid rgba(255, 255, 255, 0.27);
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 40px 60px;
  position: relative;
  z-index: 1;

  @media (max-width: 768px) {
    padding: 30px 20px;
    gap: 20px;
  }

  @media (max-width: 480px) {
    padding: 20px 15px;
    gap: 16px;
  }
`;

export const GalilLogo = styled.img`
  width: 200px;
  height: auto;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    width: 150px;
  }

  @media (max-width: 480px) {
    width: 120px;
  }
`;

export const SuccessTitle = styled.h1`
  font-size: 28px;
  font-weight: bold;
  color: ${colors.theme.galilWhite};
  margin: 0;
  direction: rtl;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 24px;
  }

  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

export const SuccessMessage = styled.p`
  font-size: 18px;
  line-height: 1.6;
  color: ${colors.theme.galilWhite};
  margin: 0;
  white-space: pre-line;
  direction: rtl;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 1.5;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    line-height: 1.4;
  }
`;

export const SuccessMessageComputer = styled.p`
  font-size: 18px;
  font-weight: bold;
  line-height: 1.6;
  color: ${colors.theme.galilWhite};
  margin: 0;
  white-space: pre-line;
  direction: rtl;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 1.5;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    line-height: 1.4;
  }
`;

export const LoginButton = styled.button`
  background: ${colors.theme.galilGreen};
  color: white;
  border: none;
  border-radius: 8px;
  padding: 14px 40px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
  margin-top: 10px;
  width: 100%;
  max-width: 320px;

  &:hover {
    background: ${colors.theme.galilGreen80};
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 480px) {
    padding: 12px 30px;
    font-size: 16px;
    min-height: 44px;
  }
`;
